/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartModifierSchema } from "./banquetCartModifierSchema.ts";

export const banquetCartGroupModifierSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(banquetCartModifierSchema),
});
